module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEyIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xLjQxIDAuNTg5ODQzTDYgNS4xNjk4NEwxMC41OSAwLjU4OTg0NEwxMiAxLjk5OTg0TDYgNy45OTk4NEwtNi4xNjMzMWUtMDggMS45OTk4NEwxLjQxIDAuNTg5ODQzWiIgZmlsbD0iIzRFNjZBNiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vector-tick.svg
// module id = 1DsQ
// module chunks = 1